__turbopack_context__.v({
  "centerText": "Text-module__GbnEhq__centerText",
  "font-2xl": "Text-module__GbnEhq__font-2xl",
  "font-3xl": "Text-module__GbnEhq__font-3xl",
  "font-4xl": "Text-module__GbnEhq__font-4xl",
  "font-5xl": "Text-module__GbnEhq__font-5xl",
  "font-body": "Text-module__GbnEhq__font-body",
  "font-callout": "Text-module__GbnEhq__font-callout",
  "font-caption": "Text-module__GbnEhq__font-caption",
  "font-caption2": "Text-module__GbnEhq__font-caption2",
  "font-footnote": "Text-module__GbnEhq__font-footnote",
  "font-h1": "Text-module__GbnEhq__font-h1",
  "font-h2": "Text-module__GbnEhq__font-h2",
  "font-h3": "Text-module__GbnEhq__font-h3",
  "font-lg": "Text-module__GbnEhq__font-lg",
  "font-md": "Text-module__GbnEhq__font-md",
  "font-sm": "Text-module__GbnEhq__font-sm",
  "font-xl": "Text-module__GbnEhq__font-xl",
  "font-xs": "Text-module__GbnEhq__font-xs",
  "lineHeight-large": "Text-module__GbnEhq__lineHeight-large",
  "lineHeight-medium": "Text-module__GbnEhq__lineHeight-medium",
  "lineHeight-normal": "Text-module__GbnEhq__lineHeight-normal",
  "lineHeight-small": "Text-module__GbnEhq__lineHeight-small",
  "strikeThrough": "Text-module__GbnEhq__strikeThrough",
  "text": "Text-module__GbnEhq__text",
  "weight-bold": "Text-module__GbnEhq__weight-bold",
  "weight-extrabold": "Text-module__GbnEhq__weight-extrabold",
  "weight-light": "Text-module__GbnEhq__weight-light",
  "weight-medium": "Text-module__GbnEhq__weight-medium",
  "weight-regular": "Text-module__GbnEhq__weight-regular",
  "weight-semibold": "Text-module__GbnEhq__weight-semibold",
});
